<app-modal-v2 #modal customClassName="trial-notification-template-form">
  <div class="modal-content">

    <div class="modal-header">
      <h2 class="modal-title">{{ notificationTemplate.id ? 'Update' : 'Add' }} {{NotificationType[form.value.notificationType]}} Notification</h2>

      <div class="culture-select">
        <app-input-select #cultureSelect [items]="filteredCultures" [parentForm]="form" controlName="selectedCulture"
                          [allowFiltering]="true" [allowClear]="false" (onFilter)="onCultureFiltered($event)"
                          searchInputPlaceholder="Search..."></app-input-select>
      </div>
    </div>
    <div class="modal-body">

      <!-- Start: Notification title -->
      @for (cultureForm of cultureForms; track form) {
        <form [formGroup]="cultureForm"
              [class.visibility-hidden]="cultureForm.value.culture !== form.value.selectedCulture">
          <div class="form-group">
            <label for="name">
              Notification Name
              @if (cultureForm.value.culture === 'en') {
                <sup>*</sup>
              }
            </label>
            <input type="text" formControlName="name" placeholder="Enter a name for the notification...">
          </div>
        </form>
      }
      <!-- End: Notification title -->

      <!-- Start: Visit notification offset -->
      <div class="offset-container" [class.visibility-hidden]="!isVisitNotification()">
        <form [formGroup]="form">
          <div class="offset-amount">
            <div class="form-group">
              <label for="name">
                Send
              </label>
              <input type="text" formControlName="offsetAmount">
            </div>
          </div>

          <div class="offset-unit">
            <div class="form-group">
              <label>&nbsp;</label>
              <app-input-select #offsetUnitSelect [items]="offsetUnitOptions" [parentForm]="form" controlName="offsetUnit"
                                searchInputPlaceholder="Select..."></app-input-select>
            </div>
          </div>

          <div class="after-event">
            <div class="form-group">
              <label>&nbsp;</label>
              <app-input-select #afterEventSelect [items]="afterEventOptions" [parentForm]="form" controlName="afterEvent"
                                searchInputPlaceholder="Select..."></app-input-select>
            </div>
          </div>
        </form>
      </div>
      <!-- End: Visit notification offset -->

      <!-- Start: Frequency, Day of Week, Time -->
      <div class="frequency-container" [class.visibility-hidden]="!isEdiaryNotification()">
        <form [formGroup]="form">
          <!-- Start: Disabled placeholder for trigger -->
          <div class="trigger">
            <div class="form-group">
              <label>Trigger <sup>*</sup></label>
              <div class="fake-field disabled" [class.visibility-hidden]="!notificationTemplate.id">{{ selectedTriggerLabel() }}</div>
              <div [class.visibility-hidden]="notificationTemplate.id">
                <app-input-select [items]="triggerOptions" [parentForm]="form" controlName="trigger"
                                  searchInputPlaceholder="Select..."></app-input-select>
              </div>
            </div>
          </div>
          <!-- End: Disabled placeholder for trigger -->

          <!-- Start: Diary response expression offset amount -->
          <div class="expression-offset-amount" [class.visibility-hidden]="form.value.trigger !== '3'">
            <div class="form-group">
              <label for="name">
                Send
              </label>
              <input type="text" formControlName="expressionOffsetAmount">
            </div>
          </div>
          <!-- End: Diary response expression offset amount -->

          <!-- Start: Diary response expression offset unit -->
          <div class="expression-offset-unit" [class.visibility-hidden]="form.value.trigger !== '3'">
            <div class="form-group">
              <label>&nbsp;</label>
              <app-input-select #expressionOffsetUnitSelect [items]="offsetUnitOptions" [parentForm]="form" controlName="expressionOffsetUnit"
                                searchInputPlaceholder="Select..."></app-input-select>
            </div>
          </div>
          <!-- End: Diary response expression offset unit -->

          <!-- Start: Diary response expression send after -->
          <div class="expression-after-event" [class.visibility-hidden]="form.value.trigger !== '3'">
            <div class="form-group">
              <label>&nbsp;</label>
              <div class="fake-field disabled">After submission</div>
            </div>
          </div>
          <!-- End: Diary response expression send after -->

          <!-- Start: Missed diary entries -->
          <div class="missed-entries" [class.visibility-hidden]="form.value.trigger !== '2'">
            <div class="form-group">
              <label>Missed Entries <sup>*</sup></label>
              <input type="number" formControlName="ediaryMissedEntryCount">
            </div>
          </div>
          <!-- End: Missed diary entries s -->

          <div class="frequency" [class.visibility-hidden]="form.value.trigger !== '1'">
            <div class="form-group">
              <label>Frequency <sup>*</sup></label>
              <app-input-select [items]="frequencyOptions" [parentForm]="form" controlName="frequency"
                                searchInputPlaceholder="Select..."></app-input-select>
            </div>
          </div>
          <div class="day-of-week" [class.visibility-hidden]="form.value.trigger !== '1' || form.value.frequency !== 'weekly'">
            <div class="form-group">
              <label>Day of Week <sup>*</sup></label>
              <app-input-select [items]="dayOfWeekOptions" [parentForm]="form" controlName="dayOfWeek"
                                searchInputPlaceholder="Select..."></app-input-select>
            </div>
          </div>
          <div class="day-of-month" [class.visibility-hidden]="form.value.trigger !== '1' || form.value.frequency !== 'monthly'">
            <div class="form-group">
              <label>Day of Month <sup>*</sup></label>
              <app-input-select [items]="dayOfMonthOptions" [parentForm]="form" controlName="dayOfMonth"
                                searchInputPlaceholder="Select..."></app-input-select>
            </div>
          </div>
          <div class="time" [class.visibility-hidden]="form.value.trigger !== '1'">
            <div class="form-group">
              <label>Patient Time <sup>*</sup></label>
              <app-input-timepicker formControlName="time"></app-input-timepicker>
            </div>
          </div>
        </form>
      </div>
      <!-- End: Frequency, Day of Week, Time -->

      <!-- Start: Diary response expression -->
      @if (diaryForm && diaryForm.id && isEdiaryNotification() && form.value.trigger === '3') {
        <app-trial-notification-conditions #conditionsManager [diaryForm]="diaryForm" (changed)="onConditionsChanged($event)"></app-trial-notification-conditions>
      }
      <!-- End: Diary response expression -->

      <!-- Start: Mandatory notification toggle -->
      <div class="checkbox-toggle">
        <form [formGroup]="form">
          <div class="checkbox-wrap">
            <label class="checkbox" [class.checked]="form.value.mandatoryNotification">
              <input type="checkbox" id="mandatoryNotification" formControlName="mandatoryNotification" value="true">
              <span></span>
            </label>
            <label class="checkbox-label" for="mandatoryNotification">
              Mandatory Notification
              <span class="checkbox-note">This notification must be sent and cannot be disabled by patients.</span>
            </label>
          </div>
        </form>
      </div>
      <!-- End: Mandatory notification toggle -->

      <!-- Start: App notification enabled toggle -->
      <div class="checkbox-toggle">
        <form [formGroup]="form">
          <div class="checkbox-wrap">
            <label class="checkbox" [class.checked]="form.value.appNotificationEnabled">
              <input type="checkbox" id="appNotificationEnabled" formControlName="appNotificationEnabled" value="true">
              <span></span>
            </label>
            <label class="checkbox-label" for="appNotificationEnabled">Enable App Notifications</label>
          </div>
        </form>
      </div>
      <!-- End: App notification enabled toggle -->

      <!-- Start: App notification content -->
      <div class="indented-container" [class.visibility-hidden]="!form.value.appNotificationEnabled">
        @for (cultureForm of cultureForms; track form) {
          <form [formGroup]="cultureForm"
                [class.visibility-hidden]="cultureForm.value.culture !== form.value.selectedCulture">
            <div class="form-group">
              <label for="appTitle">
                App Notification Title
                @if (cultureForm.value.culture === 'en') {
                  <sup>*</sup>
                }
              </label>
              <input type="text" formControlName="appTitle" placeholder="Enter app notification title...">
            </div>

            <div class="form-group">
              <label for="appContent">
                App Notification Content
                @if (cultureForm.value.culture === 'en') {
                  <sup>*</sup>
                }
              </label>
              <textarea class="app-content" formControlName="appContent"
                        placeholder="Enter app notification content..."></textarea>
            </div>
          </form>
        }
      </div>
      <!-- End: App notification content -->

      <!-- Start: Email notification enabled toggle -->
      <div class="checkbox-toggle">
        <form [formGroup]="form">
          <div class="checkbox-wrap">
            <label class="checkbox" [class.checked]="form.value.emailNotificationEnabled" [style.cursor]="form.value.mandatoryNotification ? 'not-allowed' : 'pointer'">
              <input type="checkbox" id="emailNotificationEnabled" formControlName="emailNotificationEnabled" value="true">
              <span></span>
            </label>
            <label class="checkbox-label" for="emailNotificationEnabled">Enable Email Notifications</label>
          </div>
        </form>
      </div>
      <!-- End: Email notification enabled toggle -->

      <!-- Start: Email notification content -->
      <div class="indented-container" [class.visibility-hidden]="!form.value.emailNotificationEnabled">
        @for (cultureForm of cultureForms; track form) {
          <form [formGroup]="cultureForm"
                [class.visibility-hidden]="cultureForm.value.culture !== form.value.selectedCulture">
            <div class="form-group">
              <label for="emailSubject">
                Email Notification Subject
                @if (cultureForm.value.culture === 'en') {
                  <sup>*</sup>
                }
              </label>
              <input type="text" formControlName="emailSubject" placeholder="Enter email notification subject...">
            </div>

            <div class="form-group">
              <label for="emailContent">
                Email Notification Content
                @if (cultureForm.value.culture === 'en') {
                  <sup>*</sup>
                }
              </label>
              <textarea class="app-content" formControlName="emailContent"
                        placeholder="Enter email notification content..."></textarea>
            </div>
          </form>
        }
      </div>
      <!-- End: Email notification content -->

      <!-- Start: Tokens -->
      @if (isVisitNotification() && (form.value.appNotificationEnabled || form.value.emailNotificationEnabled)) {
        <div class="tokens">
          <h3>Tokens</h3>
          <ul>
            <li *ngFor="let token of tokens"><span>{{ '{'+token.key+'}' }}</span> <span>{{ token.description }}</span></li>
          </ul>
        </div>
      }
      <!-- End: Tokens -->

    </div>

    <div class="modal-footer">
      <div class="modal-footer-buttons">
        <app-button text="Cancel" variant="secondary" width="fill"
                    type="button" (click)="modal.hide()"/>

        <app-button text="Save" variant="primary" width="fill" [isBusy]="form.value.isBusy"
                    [disabled]="!form.valid || !cultureFormsValid()"
                    type="button"
                    (click)="onSubmit()"/>
      </div>
    </div>

  </div>
</app-modal-v2>
